import { createFileRoute } from '@tanstack/react-router';

import { AdvertisingPage } from '@/features/admin-terminal/components/advertising/advertising-page';

export const Route = createFileRoute('/_admin/admin/advertising')({
  component: AdvertisingPage,
});
